import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';

import TkForm from '@/../bower_components/teknisavuecomponents/components/TkForm.vue';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';
import MarcacaoRepository from '@/assets/ts/offline/repository/MarcacaoRepository';
import Field from '@/../bower_components/teknisavuecomponents/assets/interfaces/Field';
import { ControleAcessoController } from '@/assets/ts/controller/ControleAcessoController';
import Util from '@/../bower_components/teknisavuecomponents/assets/utils/Util';
import UtilPG from '@/assets/ts/utils/Util';


@Component({
  name: 'GerenciarPermissoes',
  components: {
    TkForm
  },
})
class GerenciarPermissoes extends Vue {

  // #region [ PROPS ]
  @Prop({ default: false })
  private readonly value: boolean;

  @Prop({ default: false })
  private readonly rowProp: any;

  // #region [ EVENTS ]
  @Emit('after-save')
  private emitAfterSave() {}

  @Emit('input')
  private emitInput(value: boolean) {}

  // #region [ WATCHERS ]
  @Watch('value', { immediate: true })
  private valueOnChange() {
    this.internalValue = this.value;
    this.reload();
    this.alertaIsPerfilAdm();
  }

  private get cardTitle(): string {
    return `Gerenciamento de Acesso - ${this.rowProp.NMPERFILACESSO}`;
  }

  private internalValue = false;
  private loading = false;
  private loadingPermissoes = false;
  private row: any = {};

  private itemsPerPage = 10;

  private permissoes = [];
  private permissoesOriginal = [];
  private permissoesAtuais = [];
  private modalDescricaoModuloVisivel = false;
  private selectedModule = null;

  private projetoSelecionado = "PG";
  private projetos = [
    { text: "Portal do Gestor", value: "PG" },
    { text: "Portal Funcionário", value: "PF" }
  ];

  private headers = [
    { text: 'Nome do Módulo', value: 'NOME', sortable: false },
    { text: 'Visualizar', value: 'IDVISUALIZAR', sortable: false },
    { text: 'Criar', value: 'IDCRIAR', sortable: false },
    { text: 'Atualizar', value: 'IDATUALIZAR', sortable: false},
    { text: 'Excluir', value: 'IDDELETAR', sortable: false },
    { text: 'Ações', value: 'ACTION', sortable: false },
  ];

  private get fields(): Field[] {
    const fields = [
    ];

    return fields;
  }

  // #region [ METHODS ]

  private async reload() {
    if(!this.internalValue) return;

    this.loadingPermissoes = true;
    this.permissoes = [];
    const nrPerfilAcesso = this.rowProp.NRPERFILACESSO;

    try {
      const permissoes = await ControleAcessoController.getPermissoesAcessoPerfil(nrPerfilAcesso, this.projetoSelecionado, false);

      this.permissoes = permissoes;

      this.permissoesOriginal = Util.deepCopy(permissoes);
      this.permissoesAtuais = [];
    } catch (err) {
    } finally {
      this.loadingPermissoes = false;
    }
  }

  private closePopup() {
    this.internalValue = false;
    this.emitInput(this.internalValue);
    this.row = {};
  }

  private onFieldInput(fieldName, value) {
  }

  private updatePermission(item: any, field: string) {
    console.log(`Alteração detectada: ${field} ->`, item[field]);
    
    // Opcional: Atualizar um array com as permissões alteradas para salvar depois
    const index = this.permissoesAtuais.findIndex(p => p.NOME === item.NOME);
    if (index !== -1) {
      this.permissoesAtuais[index][field] = item[field];
    } else {
      this.permissoesAtuais.push({ ...item });
    }
  }

  private async saveEdit() {

    const permissoesAlteradas = this.getPermissoesAlteradas();

    if (!permissoesAlteradas.length) {
      const message = 'Nenhuma permissão foi modificada no gerenciamento de acesso!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);
      return;
    }
  
    try {

      const res = await ControleAcessoController.atualizarPermissoesAcesso(this.rowProp.NRPERFILACESSO, permissoesAlteradas);

      this.reload();

      //this.closePopup();
      //this.emitAfterSave();
    } catch (error) {}

  }

  private getPermissoesAlteradas() {
    const permissoesAlteradas = this.permissoesAtuais.filter((atual) => {

      const original = this.permissoesOriginal.find(original => 
        original && atual && 
        original.IDCONTROLEMODULO === atual.IDCONTROLEMODULO
      );

      if(!atual || !original) return false;
  
      // Verifica se algum campo foi alterado
      return (
        atual.IDVISUALIZAR !== original.IDVISUALIZAR ||
        atual.IDCRIAR !== original.IDCRIAR ||
        atual.IDATUALIZAR !== original.IDATUALIZAR ||
        atual.IDDELETAR !== original.IDDELETAR
      );
    });

    return permissoesAlteradas;
  }

  private abrirModalDescricaoModulo(permissao: any) {
    this.selectedModule = permissao;
    this.modalDescricaoModuloVisivel = true;
  }

  private alterarProjeto() {
    this.reload();
  }

  private alertaIsPerfilAdm() {
    if(!this.internalValue) return;

    if (this.rowProp && this.rowProp.IDPERFILACESSOADM == UtilPG.ID_TRUE) {
      const message = 'O controle de acesso não terá impacto em um perfil de administrador (ADM).';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ALERT);
    }
    
  }

}

export default GerenciarPermissoes;